import { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {Helmet} from "react-helmet"

import local from '../app_localisation';

export default function NotFound() {
    const setup = useSelector(state => state.site.setup);
    
    // Явно проверяем, что язык валиден, иначе используем 'ru' по умолчанию
    let LANG = ['ru', 'en', 'de'].includes(setup.lang) ? setup.lang : 'ru';

    const messages = {
        ru: {
            title: 'Страница не найдена',
            code: '404',
            message: 'Извините, запрашиваемая страница не найдена',
            back: 'Вернуться на главную'
        },
        en: {
            title: 'Page Not Found',
            code: '404',
            message: 'Sorry, the page you are looking for does not exist',
            back: 'Back to Home'
        },
        de: {
            title: 'Seite nicht gefunden',
            code: '404',
            message: 'Entschuldigung, die gesuchte Seite existiert nicht',
            back: 'Zurück zur Startseite'
        }
    };

    const msg = messages[LANG];

    return (
        <Fragment>
            <Helmet>
                <title>{msg.title}</title>
            </Helmet>
            <div className='pages lk tac'>
                <h1 className='red' style={{ fontSize: '4rem' }}>{msg.code}</h1>
                <h2>{msg.message}</h2>
                <br/>
                <Link to={`/${LANG}/`} className="btn submit w50">
                    {msg.back}
                </Link>
            </div>
        </Fragment>
    );
}
